/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  InvestigationCategoriesResponseDto
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns all investigation conclusion categories with their associated conclusions for the authenticated user's organization
 * @summary Get investigation conclusion categories for control results
 */
export const getInvestigationConclusionCategories = (
    
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<InvestigationCategoriesResponseDto>(
      {url: `/investigation-conclusions/categories`, method: 'GET', signal
    },
      options);
    }
  

export const getGetInvestigationConclusionCategoriesQueryKey = () => {
    return [`/investigation-conclusions/categories`] as const;
    }

    
export const getGetInvestigationConclusionCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getInvestigationConclusionCategories>>, TError = null>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvestigationConclusionCategories>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvestigationConclusionCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvestigationConclusionCategories>>> = ({ signal }) => getInvestigationConclusionCategories(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvestigationConclusionCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvestigationConclusionCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getInvestigationConclusionCategories>>>
export type GetInvestigationConclusionCategoriesQueryError = null


export function useGetInvestigationConclusionCategories<TData = Awaited<ReturnType<typeof getInvestigationConclusionCategories>>, TError = null>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvestigationConclusionCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvestigationConclusionCategories>>,
          TError,
          Awaited<ReturnType<typeof getInvestigationConclusionCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvestigationConclusionCategories<TData = Awaited<ReturnType<typeof getInvestigationConclusionCategories>>, TError = null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvestigationConclusionCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvestigationConclusionCategories>>,
          TError,
          Awaited<ReturnType<typeof getInvestigationConclusionCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvestigationConclusionCategories<TData = Awaited<ReturnType<typeof getInvestigationConclusionCategories>>, TError = null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvestigationConclusionCategories>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get investigation conclusion categories for control results
 */

export function useGetInvestigationConclusionCategories<TData = Awaited<ReturnType<typeof getInvestigationConclusionCategories>>, TError = null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvestigationConclusionCategories>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvestigationConclusionCategoriesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



